const BaseModule = require('../../90_utils/base/BaseModule');

class SimpleSlider extends BaseModule {

	constructor(el, params) {

		super(el);

		// param defaults

		this.defaults = {
			indexOffset: 			0,
			slidesPerSet: 			1, // number of visible slides
			slidesMovedPerClick: 	1, // slide distance per click (this can be left blank - defaults to slidesPerSet)
			indexShiftPerClick: 	1, // index shift per click (this can be left blank - defaults to slidesMovedPerClick)
			isHorizontal: 			true,
		};

		// flags

		this._isFirstConfig = true;
		this._isListening = false;
		this._isEnabled = false;

		//

		this.updateParams(params);
	}

	// reinitialize entire configuration based on new params

	updateParams(params){

		// disable while updating

		this.disable();

		//

		this.params = params || [];

		this.indexOffset = parseInt(this.checkVal(this.params.indexOffset, this.defaults.indexOffset));
		this.slidesPerSet = parseInt(this.checkVal(this.params.slidesPerSet, this.defaults.slidesPerSet));
		this.slidesMovedPerClick = parseInt(this.checkVal(this.params.slidesMovedPerClick, this.slidesPerSet));
		this.indexShiftPerClick = parseInt(this.checkVal(this.params.indexShiftPerClick, this.slidesMovedPerClick));
		this.isHorizontal = this.checkVal(this.params.isHorizontal, this.defaults.isHorizontal);

		this.$leftArrow = this.checkVals([this.params.$leftArrow, this.$el.find('.arrow--left')]);
		this.$rightArrow = this.checkVals([this.params.$rightArrow, this.$el.find('.arrow--right')]);
		this.$upArrow = this.checkVals([this.params.$upArrow, this.$el.find('.arrow--up')]);
		this.$downArrow = this.checkVals([this.params.$downArrow, this.$el.find('.arrow--down')]);

		this.$progress = this.checkVals([this.params.$progress, this.$el.find('.progress')]);

		if(this.$progress){
			this.$progressIndex = this.checkVals([this.params.$progressIndex, this.$progress.find('.progress-numbers--index')]);
			this.$progressTotal = this.checkVals([this.params.$progressTotal, this.$progress.find('.progress-numbers--total')]);
		}

		this.$slidesContainer = this.checkVals([this.params.$slidesContainer, this.$el.find('ul.slides')]);

		// find slides

		this.$slides = this.$slidesContainer.find('>li');

		// throw error if slides cannot be found

		if(!this.$slides.length){ throw new Error('Could not find slides (>li) within $slidesContainer:', this.$slidesContainer); }

		//

		this.index = this.indexOffset;

		this._lastIndex = 0;
		this._clickIndex = 0;
		this._total = this.$slides.length;
		this._slideWidth = 0;

		// if total slides are too few for full set moves, limit slides per click

		if(this._total - this.slidesMovedPerClick < this.slidesMovedPerClick){
			this.slidesMovedPerClick = this._total - this.slidesMovedPerClick;
		}

		if(this._total - this.indexShiftPerClick < this.indexShiftPerClick){
			this.indexShiftPerClick = this._total - this.indexShiftPerClick;
		}

		if(this._isFirstConfig){

			this._isFirstConfig = false;

			$(() => {
				this._domReady(); // will re-enable
			});
		}
	}

	//

	_domReady(){

		super._domReady();

		this._updateProgress();
	}

	// listeners

	_addListeners(){

		super._addListeners();

		if(!this._isListening){

			this._isListening = true;

			if(this.$leftArrow){
				this.$leftArrow.on('click', this._onLeftClick.bind(this));
				this.$leftArrow.on('mouseenter', this._onLeftOver.bind(this));
				this.$leftArrow.on('mouseleave', this._onLeftOut.bind(this));
			}

			if(this.$rightArrow){
				this.$rightArrow.on('click', this._onRightClick.bind(this));
				this.$rightArrow.on('mouseenter', this._onRightOver.bind(this));
				this.$rightArrow.on('mouseleave', this._onRightOut.bind(this));
			}

			if(this.$upArrow){
				this.$upArrow.on('click', this._onUpClick.bind(this));
				this.$upArrow.on('mouseenter', this._onUpOver.bind(this));
				this.$upArrow.on('mouseleave', this._onUpOut.bind(this));
			}

			if(this.$downArrow){
				this.$downArrow.on('click', this._onDownClick.bind(this));
				this.$downArrow.on('mouseenter', this._onDownOver.bind(this));
				this.$downArrow.on('mouseleave', this._onDownOut.bind(this));
			}
		}
	}

	_removeListeners(){

		super._removeListeners();

		if(this._isListening){

			this._isListening = false;

			if(this.$leftArrow){
				this.$leftArrow.off('click', this._onLeftClick.bind(this));
				this.$leftArrow.off('mouseenter', this._onLeftOver.bind(this));
				this.$leftArrow.off('mouseleave', this._onLeftOut.bind(this));
			}

			if(this.$rightArrow){
				this.$rightArrow.off('click', this._onRightClick.bind(this));
				this.$rightArrow.off('mouseenter', this._onRightOver.bind(this));
				this.$rightArrow.off('mouseleave', this._onRightOut.bind(this));
			}

			if(this.$upArrow){
				this.$upArrow.off('click', this._onUpClick.bind(this));
				this.$upArrow.off('mouseenter', this._onUpOver.bind(this));
				this.$upArrow.off('mouseleave', this._onUpOut.bind(this));
			}

			if(this.$downArrow){
				this.$downArrow.off('click', this._onDownClick.bind(this));
				this.$downArrow.off('mouseenter', this._onDownOver.bind(this));
				this.$downArrow.off('mouseleave', this._onDownOut.bind(this));
			}
		}
	}

	// global event methods

	_resize(){
		this._resetSlidesContainer();
	}

	// element event methods
	// left

	_onLeftClick(){
		this.prev();
	}

	_onLeftOver(){ }
	_onLeftOut(){ }

	// right

	_onRightClick(){
		this.next();
	}

	_onRightOver(){ }
	_onRightOut(){ }

	// up

	_onUpClick(){
		this.prev();
	}

	_onUpOver(){ }
	_onUpOut(){ }

	// down

	_onDownClick(){
		this.next();
	}

	_onDownOver(){ }
	_onDownOut(){ }

	// slide controls

	next(){
		this.triggerEvent('next', {index:this.index + this.indexShiftPerClick, total:this._total});
		this.seekTo(this.index + this.indexShiftPerClick, 1);
	}

	prev(){
		this.triggerEvent('prev', {index:this.index - this.indexShiftPerClick, total:this._total});
		this.seekTo(this.index - this.indexShiftPerClick, -1);
	}

	seekTo(newIndex, indexDelta){

		if(typeof(newIndex) !==	'undefined' && !isNaN(newIndex)){

			newIndex = this.getRangeIndex(newIndex);

			if(newIndex !== this.index){

				if(isNaN(indexDelta)){
					if(newIndex > this.index){ indexDelta = this.slidesMovedPerClick; }
					else { indexDelta = 0 - this.slidesMovedPerClick; }
				}
				else {
					indexDelta *= this.slidesMovedPerClick;
				}

				// set new index

				this._lastIndex = this.index;
				this.index = newIndex;
				this._clickIndex += indexDelta; // motion does not always max index

				// make sure slides are properly ordered

				this._arrangeSlides();

				// update progress numbers

				this._updateProgress();

				// slide to new position

				this.$el.addClass('is-sliding');
				this.$el.removeClass('is-peeking');

				if(this.isHorizontal){
					TweenMax.set(this.$slidesContainer, {x:0 - this._clickIndex * this._slideWidth, y:0, force3D:true});
				}
				else {
					TweenMax.set(this.$slidesContainer, {x:0, y:0 - this._clickIndex * this._slideHeight, force3D:true});
				}

				window.utils.AnimationUtils.offTransitionComplete(this.$slidesContainer);
				window.utils.AnimationUtils.oneTransitionComplete(this.$slidesContainer, () => {
					// start callback
				}, () => {
					this.$el.removeClass('is-sliding');
				}, true);

				// fire event

				this.triggerEvent('seek', {index:this.index, total:this._total});
			}
		}
	}

	// move slide container

	_resetSlidesContainer(){

		TweenMax.set(this.$slidesContainer, {clearProps: 'width, height'});

		// slide specs

		let $currentSlide = this.$slides.eq(this.index);
		this._slideWidth = $currentSlide.outerWidth(true);
		this._slideHeight = $currentSlide.outerHeight(true);

		// container specs

		let transformObj = {x:0, y:0};

		if(this.isHorizontal){
			transformObj.width = this._slideWidth * this.slidesPerSet;
			transformObj.height = this._slideHeight;
		}
		else {
			transformObj.width = this._slideWidth;
			transformObj.height = this._slideHeight * this.slidesPerSet;
		}

		TweenMax.set(this.$slidesContainer, transformObj);

		//

		this._clickIndex = 0;
		this._arrangeSlides();
	}

	// arrange slides depending on index

	_arrangeSlides(){

		let workingIndex = this.getRangeIndex(this.index);
		let nextIndex = this.getRangeIndex(workingIndex + (this.slidesPerSet - 1) + this.indexShiftPerClick);
		let prevIndex = this.getRangeIndex(workingIndex - this.indexShiftPerClick);

		let $currentSlide = this.$slides.eq(workingIndex);
		let $nextSlide = this.$slides.eq(nextIndex);
		let $prevSlide = this.$slides.eq(prevIndex);

		// move slides to correct locations

		this.$slides.removeClass('is-front');

		//

		$currentSlide.addClass('is-front');

		for(let i=0; i<this.slidesPerSet; i++){

			// slides in set

			let $setNeighbor = this.$slides.eq(this.getRangeIndex($currentSlide.index() + i));
			$setNeighbor.addClass('is-front');

			if(this.isHorizontal){
				TweenMax.set($setNeighbor, {x:(this._clickIndex + i) * this._slideWidth, y:0});
			}
			else {
				TweenMax.set($setNeighbor, {x:0, y:(this._clickIndex + i) * this._slideHeight});
			}

			// last slides

			let $lastSlide = this.$slides.eq(this.getRangeIndex(this._lastIndex + i));
			$lastSlide.addClass('is-front is-prev');
		}
	}

	// update numbers

	_updateProgress(){

		if(this.$progressIndex && this.$progressIndex.length){
			this.$progressIndex.html(window.utils.NumberUtils.formatNumber(this.index + 1, 2));
		}

		if(this.$progressTotal && this.$progressTotal.length){
			this.$progressTotal.html(window.utils.NumberUtils.formatNumber(this._total, 2));
		}
	}

	// utils

	getRangeIndex(newIndex, wrap){

		// return valid index based on newIndex compared to valid range
		// will wrap by default (meaning -2 will become total - 2)
		// if wrap is disabled, index will return at lower or higher limit of range

		return window.utils.NumberUtils.getRangeIndex(newIndex, 0, this._total, wrap);
	}
}

module.exports = SimpleSlider;
